
/**
 * 日期格式转换
 * YYYY-MM-DD HH:MM:SS 转为 MM/DD/YYYY HH:MM:SS
 * @param {string} date 
 * @returns 
 */
export const dateFormat = (dateStr) => {
    let temp = dateStr || ''
    if (temp) {
        const d1 = dateStr.split(' ') || []
        let d2 = []
        let d3 = []
        if (d1.length) {
            d2 = d1[0].split('-') || []
        }
        if (d1.length) {
            d3 = d1[1].split(':') || []
        }
        if (d2.length === 3 && d3.length === 3) {
            const hours = d3[0];
            let hour12 = hours % 12;
            hour12 = hour12 === 0 ? 12 : hour12; // 0点转换为12点
            if(hour12 < 10) hour12 = '0' + hour12;
            temp = d2[1] + '/' + d2[2] + '/' + d2[0] + ' ' + hour12 + ':' + d3[1]
            if (parseInt(d3[0], 10) >= 12) {
              temp += ' PM';
            } else {
              temp += ' AM';
            }
        }
    }
    return temp
}

// 把 image 转换为 canvas 对象
async function imgToCanvas(image) {
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    canvas.getContext("2d").drawImage(image, 0, 0);
    return canvas;
  }

  // base64 图片转 file
  function base64ToFile(base64, fileName) {
    const data = base64.split(',');
    console.info('data--', JSON.stringify(data).substring(0,200))
    // 画布太大时，获取不到 base64，提示图片太大
    if(!data[1]){
      return false;
    }
    const type = data[0].match(/:(.*?);/)[1];
    const suffix = type.split('/')[1];
    const bstr = window.atob(data[1]);
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    // 利用构造函数创建 File 文件对象
    // new File(bits, name, options)
    const file = new File([u8arr], `${fileName}.${suffix}`, {
      type: type
    })
    // 将 File 文件对象返回给方法的调用者
    return file;
  
  }
  
  async function imgToBlod(image, file) {
    const fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
    let imgName = file.name.split('.')[0]
    console.info('imgToBlod--', image)
    // 把 image 转换为 canvas 对象，toDataURL 降低内存
    const can = await imgToCanvas(image)
    console.info('toDataURL--',can.toDataURL().substring(0,200))
    let base64 = null
    if (fileSize < 2) {
      //如果图片小于 2M 那么不执行压缩操作，格式文件传入
      base64 = can.toDataURL("image/jpeg", 1);
    } else if (fileSize > 2 && fileSize < 5) {
      //如果图片大于 1M 并且小于 5M 那么压缩 0.5
      base64 = can.toDataURL("image/jpeg", 0.5);
    } else {
      //如果图片超过 5M 那么压缩 0.3
      base64 = can.toDataURL("image/jpeg", 0.3);
    }
    const name = file.name.substr(0, file.name.indexOf('.'))
    console.info('base64--', JSON.stringify(base64).substring(0,200), 'name--', name)
    const blobImg = base64ToFile(base64, name)
    return new File([blobImg], `${imgName}.jpeg`, { type: blobImg.type });
  }
  
  //获取图片信息
  export const imgTypeChange = (file) => {
    return new Promise((resolve => {
      const imgFile = new FileReader()
      // 使用 FileReader 来把文件读入内存，并且读取文件中的数据。readAsDataURL 方法可以在浏览器主线程中异步访问文件系统，读取文件中的数据，且读取后 result 为 DataURL, DataURL 可直接 赋值给 img.src
      imgFile.readAsDataURL(file);
      imgFile.onload =  function (e) {
        console.info('e--',e)
        const image = new Image()
        // image.crossOrigin = "Anonymous";
        image.src = e.target.result; //base64 数据
        image.onload = async function () {
          resolve(await imgToBlod(image, file))
        }
      }
    }))
  }

/**
 * 获取 url 参数
 * @param  {[type]} key [description]
 * @return {[type]}     [description]
 */
  export const getUrlParam = (name) => {
    const href = window.location.href;
    let match = href.match(new RegExp('[?#&]' + name + '=([^&]+)'));
    return match ? match[1] : null;
}